export default {
  buttons: {
    bulkUpload: 'Bulk Upload',
    addUser: 'Add User',
  },
};
